// Chakra imports
import {
  Flex,
  Grid,
  Image,
  SimpleGrid,
  useColorModeValue,
} from "@chakra-ui/react";
// assets
import peopleImage from "../../../assets/img/people-image.png";
import logoChakra from "../../../assets/svg/logo-white.svg";
import auraPeakingOutOfCorner from "../../../assets/img/Aura Peaking Out Of The Corner.png";
import BarChart from "../../../components/Charts/BarChart";
import LineChart from "../../../components/Charts/LineChart";
// Custom icons (removed - no longer needed for MiniStatistics)
import React from "react";
import { rtlDashboardTableData, rtlTimelineData } from "../../../variables/general";
import ActiveUsers from "../Dashboard/components/ActiveUsers";
import BuiltByDevelopers from "../Dashboard/components/BuiltByDevelopers";
import MiniStatistics from "../Dashboard/components/MiniStatistics";
import OrdersOverview from "../Dashboard/components/OrdersOverview";
import Projects from "../Dashboard/components/Projects";
import ChartCard from "../Dashboard/components/ChartCard";
import TesseraUniversity from "../Dashboard/components/TesseraUniversity";

export default function Dashboard() {
  // Chakra Color Mode

  return (
    <Flex flexDirection='column' pt={{ base: "120px", md: "100px", lg: "60px" }}>
      <SimpleGrid columns={{ sm: 1, md: 2, xl: 4 }} spacing='24px'>
        <MiniStatistics
          title={"إجمالي المبيعات"}
          amount={"$53,000"}
          percentage={55}
        />
        <MiniStatistics
          title={"عملاء جدد"}
          amount={"2,300"}
          percentage={5}
        />
        <MiniStatistics
          title={"مستخدمو اليوم"}
          amount={"+3,020"}
          percentage={-14}
        />
        <MiniStatistics
          title={"أموال اليوم"}
          amount={"$173,000"}
          percentage={8}
        />
      </SimpleGrid>
      <Grid
        templateColumns={{ md: "1fr", lg: "1.8fr 1.2fr" }}
        templateRows={{ md: "1fr auto", lg: "1fr" }}
        my='26px'
        gap='24px'>
        <BuiltByDevelopers
          image={
            <Image
              src={auraPeakingOutOfCorner}
              alt='Aura waving'
              minWidth={{ md: "300px", lg: "auto" }}
              maxH="100%"
              maxW="100%"
              objectFit="contain"
            />
          }
        />
        <TesseraUniversity
          backgroundImage={peopleImage}
        />
      </Grid>
      <Grid
        templateColumns={{ sm: "1fr", lg: "1.3fr 1.7fr" }}
        templateRows={{ sm: "repeat(2, 1fr)", lg: "1fr" }}
        gap='24px'
        mb={{ lg: "26px" }}>
        <ActiveUsers
          title={"المستخدمين النشطين"}
          percentage={23}
          chart={<BarChart />}
        />
        <ChartCard
          title={"نظرة عامة على المبيعات"}
          percentage={5}
          chart={<LineChart />}
        />
      </Grid>
      <Grid
        templateColumns={{ sm: "1fr", md: "1fr 1fr", lg: "2fr 1fr" }}
        templateRows={{ sm: "1fr auto", md: "1fr", lg: "1fr" }}
        gap='24px'>
        <Projects
          title={"المشاريع"}
          amount={30}
          captions={["Companies", "Members", "Budget", "Completion"]}
          data={rtlDashboardTableData}
        />
        <OrdersOverview
          title={"نظرة عامة على الطلبات"}
          amount={30}
          data={rtlTimelineData}
        />
      </Grid>
    </Flex>
  );
}

